import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { usePathname } from 'hooks/usePathname.hook';
import { useStored } from 'providers/SelectorProvider.provider';
import { useTheme } from 'providers/Theme.provider';
import { selectActivityNewItems } from 'selectors/activity.selectors';

import CN from './ActivityFeedButton.module.scss';

const generateLink = (pathname) => {
  // TODO: find better way to do this, with the sidebar style using Redux state, not in URL

  const segments = pathname.split('/');
  const dayWeekSegment = segments[3];

  if (dayWeekSegment === 'day') {
    return `${segments.slice(0, 5).join('/')}/feed`;
  }

  if (dayWeekSegment === 'week') {
    return `${segments.slice(0, 6).join('/')}/feed`;
  }

  return `${pathname}/feed`;
};

const ActivityFeedButton = () => {
  const { isDarkMode } = useTheme();
  const pathname = usePathname();
  const link = generateLink(pathname);
  const count = useStored(selectActivityNewItems);

  return (
    <NavLink
      data-bem="ActivityFeedButton"
      data-count={count}
      to={link}
      activeClassName="active"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {count > 0 && <div data-bem="ActivityFeedButton__dot" className={CN.notifications} />}

      <Icon variant="bell" selected width="xl" />
    </NavLink>
  );
};

export default ActivityFeedButton;
